import ArtworkDetails from "./ArtworkDetails";

export default ArtworkDetails;
